import React from 'react'
import { connect } from 'react-redux'
import { doGetSalaryAccount, doSaveSalaryAccount } from '../../reducers/actions'

class SalaryAccountSettingDiv extends React.Component {
    state = {}

    componentDidMount = () => {
        const { onSave, onClose, dispatch } = this.props
        dispatch(doGetSalaryAccount({
            onEnd: ({ errorMessage, strSalaryAccount }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else if (strSalaryAccount) {
                    this.setState({ initValues基本信息: { '薪资科目': strSalaryAccount } })
                }
            }
        }))
    }


    handlerConfirm = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        const { onClose, dispatch } = this.props
        dispatch(doSaveSalaryAccount({
            strSalaryAccount: values.薪资科目,
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                }
            }
        }))

    }


    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    fieldset基本信息 = () => {
        return [
            { _text: '', name: '薪资科目', minWidth: '1000px', maxRows: 30 }]
    }

    render() {
        const { showBody: Body, initValues基本信息, onDelete } = this.props
        return <Body data={this} maxWidth="1100"
            controls={
                [
                    { _button: '保存', icon: 'save', handler: this.handlerConfirm },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(SalaryAccountSettingDiv)